import CandidatesBoard from './CandidatesBoard.container';

export default CandidatesBoard;
